const digest = 'ebae92f58772ce473226971ddca81fcad8418d77009b007df7d62bf15127fdf4';
const css = `._cardDetails_188nx_1{background-color:#edf7ff;border-radius:.5rem;margin-top:1rem}._cardDetailsError_188nx_7{background-color:#fff6ed;border:1px solid #b5530d;border-radius:.5rem;margin-bottom:.5rem;margin-top:1rem;padding:1rem}._heading_188nx_16{font-weight:700!important}._bodyColor_188nx_20{color:#3d3d3d}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'cardDetails': '_cardDetails_188nx_1', 'cardDetailsError': '_cardDetailsError_188nx_7', 'heading': '_heading_188nx_16', 'bodyColor': '_bodyColor_188nx_20' };
export const cardDetails = '_cardDetails_188nx_1';
export const cardDetailsError = '_cardDetailsError_188nx_7';
export const heading = '_heading_188nx_16';
export const bodyColor = '_bodyColor_188nx_20';
export { css, digest };